export default "__VITE_ASSET__CSw3DPEu__"